
import React from "react";
import { Modal } from "@mantine/core";
import LoadComp from "./LoadComp";


const Loader = ({ opened = true }: { opened?: boolean }) => {

    return (
        <>
            <Modal
                overlayColor={"#fff"}
                overlayOpacity={0.90}
                centered
                opened={opened}
                withCloseButton={false}
                shadow="false"
                className="loader_modal"
                zIndex={1000}
                onClose={() => { }}
            // sx={{ '.mantine-Paper-root': { background: 'transparent', outline: 'none', border: 'none', ':focus': { outline: 'none', border: 'none', } } }}

            >
                <LoadComp />
            </Modal>
        </>
    );
}

export default Loader;